/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import { ResetPasswordProps, HeaderProps } from "./components";

const is = require("is_js");

const SERVICE_NAME = "ResetPasswordPageService";
const log: any = LoggerModule.getInstance();

export class ResetPasswordPageService {
  private static instance: ResetPasswordPageService;
  private vapp: VApplication;
  private readonly loginRestAPI: string;
  private readonly signerPK: string;
  private headers: HeaderProps;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
    this.loginRestAPI = props?.loginRestAPI;
    this.signerPK = props?.signerPK;
    this.headers = props?.headers;
  }

  public static getInstance(props: any = {}): ResetPasswordPageService {
    if (!ResetPasswordPageService.instance) {
      ResetPasswordPageService.instance = new ResetPasswordPageService(props);
    }
    return ResetPasswordPageService.instance;
  }

  public async resetPassword(args: ResetPasswordProps) {
    log.info(`resetPassword`, args);
    let _args = {
      ...args,
      apiURL: this.loginRestAPI,
      headers: this.headers,
    };
    const agent = getAgent();
    return agent.resetPassword(_args);
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();
    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getPageContent() {
    let content: any = {};
    let compProps: any = null;

    const agent = getAgent();
    const { token, decoded } = await agent?.parseAndDecodeToken({
      signerPK: this.signerPK,
    });
    console.log("token =>", token);
    console.log("decoded =>", decoded);
    content = {
      ...content,
      initialData: {
        email: decoded?.email,
      },
      token: token,
    };
    return content;
  }
}
